<mat-form-field *ngIf='field' appearance="outline" [style.width]="field.matFormFieldWidth" [formGroup]="group">    
    <ng-container  *ngIf="field.isCurrency === true; else elseTemplate">
        <input currencyFormatter matInput  type='text' inputmode='decimal' [maxlength]="field.maxTextLength || 10" [errorStateMatcher]="matcher" autocomplete="off" [formControlName]="field.name" [placeholder]="field?.label">
    </ng-container>
    <ng-template #elseTemplate>
        <input matInput  [readonly]="field.readonly" [errorStateMatcher]="matcher"
         autocomplete="off" [formControlName]="field.name" [maxlength]="field.maxTextLength || 40" [max]="field.maxNumberLength" [placeholder]="field.label" [type]="field.inputType">

    </ng-template>
    
    <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
        <mat-error *ngIf="group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error>
    </ng-container>

    <span matSuffix *ngIf="field?.suffix">
        <ng-container *ngIf="field.suffix.icon; else isNotIcon">
            <mat-icon>{{field.suffix.text}}</mat-icon>
        </ng-container>
        <ng-template #isNotIcon >
            {{field.suffix.text}}
        </ng-template>
    </span>

    <span matPreffix *ngIf="field?.preffix">
        <ng-container *ngIf="field.preffix.icon; else isNotIcon">
            <mat-icon>{{field.preffix.text}}</mat-icon>
        </ng-container>
        <ng-template #isNotIcon>
            {{field.preffix.text}}
        </ng-template>
    </span>
</mat-form-field>